import type { FormFieldInterface } from "../dom/form";
import { HCBase, type ApiMap } from "../hc/base";
import { FormField as FormFieldV3 } from "./form";

export class HCv3 extends HCBase {
  readonly FormField = FormFieldV3;

  constructor(apiDeps: ApiMap | null) {
    super("v3", apiDeps);
  }

  protected createField(identifier: string): FormFieldInterface {
    return identifier.startsWith("custom_field_")
      ? new FormFieldV3(identifier.replace("custom_field_", ""), "custom")
      : new FormFieldV3(identifier, "system");
  }

  getAllArticles(): Promise<any> {
    const articles = this.use("articles");
    return articles.getAll();
  }
}
